import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderDuplicateControl extends Layout {
    sourceCopyControl: DataSource;
    tableOrderDuplicateControl: Table;
}
